import React from "react"
import { WarningIconMedium } from "components/page-components/Icons/medium"

export const WarningBlockquote = ({ keyword, text }) => {
  return (
    <div className="box is-bordered is-shadowless my-4">
      <div className="columns is-mobile">
        <div className="column is-narrow">
          <WarningIconMedium />
        </div>
        <div className="column has-text-mitternachtsblau">
          <span className="has-text-weight-bold">{keyword}: </span>
          <span className="is-italic">{text}</span>
        </div>
      </div>
    </div>
  )
}
